module.exports = __webpack_public_path__ + "img/x.ee636d80.svg";